import HomePage from "../../pages/HomePage";
import HomeIcon from "@mui/icons-material/Home";
import UserAccountParametersPage from "../../pages/user/UserAccountParametersPage";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import ContactPage from "../../pages/user/ContactPage";
import MesDocuments from "../../pages/prestations/MesDocuments";
import { IconAddressBook, IconMail } from '@tabler/icons-react';
import Profile from "../../pages/account-profile";
import PrestaIcon from "@mui/icons-material/SaveAlt";
import ContactPrestation from "../../pages/prestations/ContactPrestation";
import Informationslegales from "../../pages/Informationslegales/Informationslegales";


export const ExtranetPrivateRoutes = [
    // ############# Extranet Private ###############

    {
        name : "root",
        title : "Accueil",
        path : "/ui",
        component : HomePage,
        private : true,
        showMenu: false,
        icon: <HomeIcon />,
        roles: [
            'ROLE_INSURED',
        ]
    },
    {
        name : "root-redirect",
        title : "Accueil-redirect",
        path : "/ui/accueil",
        component : HomePage,
        private : true,
        showMenu: false,
        icon: <HomeIcon />,
        roles: [
            'ROLE_INSURED',
        ]    },
   /* {
        name : "services",
        title : "Services",
        path : "/ui/services",
        component : ServicesPage,
        private : true,
        showMenu: true,
        icon: <AccountBoxIcon/>,
        roles: [
            'ROLE_INSURED',
            'ROLE_COMPANY',
            'ROLE_ADMIN_COMPANY',
        ]
    },
    {
        name : "choix-perimeter",
        title : "Choix Contrat/Entreprise",
        path : "/ui/choix-perimeter",
        component : ChoixPerimeterPage,
        private : true,
        showMenu: true,
        icon: <AccountBoxIcon/>,
        roles: [
            'ROLE_COMPANY',
            'ROLE_ADMIN_COMPANY',
        ]
    },
    {
        name : "choix-profil",
        title : "Choix Profil",
        path : "/ui/choix-profil",
        component : ChoixProfilPage,
        private : true,
        showMenu: true,
        icon: <AccountBoxIcon/>,
        roles: [
            'ROLE_UNIP',
        ]
    },
    {
        name : "secure",
        title : "Secure",
        path : "/ui/secure",
        component : SecurePage,
        private : true,
        showMenu: false,
        icon: <SecurityIcon/>,
        roles: []
    },*/
    {
        name : "user-account-parameters",
        title : "Paramètres du compte",
        path : "/ui/user-parameters",
        component : UserAccountParametersPage,
        private : true,
        showMenu: false,
        icon: <SupervisedUserCircleIcon/>,
        roles: [
            'ROLE_INSURED',
        ]
    },
    {
        name : "documents",
        title : "Mes documents",
        path : "/ui/mes-documents",
        component : MesDocuments,
        private : true,
        showMenu: false,
        icon: <IconAddressBook/>,
        roles: [
            'ROLE_INSURED',
        ]
    },
    {
        name : "coordonnees",
        title : "Mes coordonnées",
        path: '/ui/mes-coordonnees',
        component: Profile,
        icon: <PrestaIcon />,
        private : true,
        showMenu: false,
        roles: [
            'ROLE_INSURED',
        ]
    },
    {
        name : "messagerie",
        title : "Ma messagerie",
        path: '/ui/ma-messagerie',
        component: ContactPrestation,
        icon: <IconMail />,
        private : true,
        showMenu: false,
        roles: [
            'ROLE_INSURED',
        ]
    },
    {
        name : "info-legals-private",
        title : "Informations légales",
        path: '/ui/informations-legales-unip',
        component: Informationslegales,
        icon: <IconMail />,
        private : false,
        showMenu: false,
        roles: [
            'ROLE_INSURED',
        ]
    },

    // ############# Contact ###############

    {
        name : "contact-us",
        title : "Contactez-nous",
        path : "/ui/contact",
        component : ContactPage,
        private : true,
        showMenu: false,
        roles: [
            'ROLE_INSURED',
        ]
    },
]
